import { useEffect } from "react";
import { Outlet, useParams, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolveLanguage } from "./supportedLanguages";

export function LocaleLayout() {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();
  const { pathname, search, hash } = useLocation();

  const resolved = resolveLanguage(lang);

  useEffect(() => {
    if (i18n.language !== resolved) {
      void i18n.changeLanguage(resolved);
    }
    localStorage.setItem("daynav.language", resolved);
  }, [resolved, i18n]);

  if (lang !== resolved) {
    const rest = pathname.replace(/^\/[^/]+/, "");
    return <Navigate to={`/${resolved}${rest}${search}${hash}`} replace />;
  }

  return <Outlet />;
}
